<template>
	<div class="manikin">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img @click="$router.replace('/Layout/Home')" src="~@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.replace('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a @click="$router.push('/Layout/learnmodel')">学习模式 &nbsp;/ &nbsp;</a>
			<a class="active">人体模型</a>
		</div>
		<div class="main" style="flex: 1;">
			<!-- <div>
        <div :class="type == 0 ? 'main_btn_active main_btn' : 'main_btn'" @click="getType(0)">肌肉</div>
        <div :class="type == 1 ? 'main_btn_active main_btn' : 'main_btn'" @click="getType(1)">骨骼</div>
			</div>-->
			<iframe src="modal/SkeletonMuscle/index.html" frameborder="0"></iframe>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			type: 0
		};
	},
	methods: {
		getType(type) {
			this.type = type;
		}
	}
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");
.manikin {
	flex: 1;
	height: 100%;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	.main_btn {
		width: 169px;
		height: 57px;
		line-height: 57px;
		color: #ffffff;
		text-align: center;
		background: #ffa216;
		opacity: 0.5;
		border-radius: 4px;
	}
	.main_btn_active {
		background: linear-gradient(270deg, #ff9900 0%, #fec937 100%);
		box-shadow: 0px 0px 6px #fec633;
	}

	iframe {
		width: 100%;
		height: 100%;
		
	}
}



</style>